export const AuthState = {
  // User data is loading
  loading: "loading",
  // User is not authenticated
  notAuthenticated: "notAuthenticated",
  // User is authenticated
  authenticated: "authenticated",
};
